import React from "react";

import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <div className="Footer">
        <a
          href="https://github.com/FatemehDashi/weather-react"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open-Source Code
        </a>{" "}
        by Fatemeh Dashi
      </div>
    </div>
  );
}
